import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import queryString from "query-string";
import BasePage from "../BasePage";
import { Tabs, Tab, Nav } from "react-bootstrap";
import { fetchScreenInfo } from "../../../../actions/generic/screenActions";
import SearchPanel from "./SearchPanel";
import OverviewPanelDatagrid from "./OverviewPanelDatagrid";
import DetailPanel from "./DetailPanel";
import TestPanel from "./TestPanel";
import LoadingSpinnerOverlay from "../../LoadingSpinnerOverlay";

export function GenericPage(props) {
  var detailPanelRef = null;
  const [state, setState] = useState({
    visiblePanels: [],
    isLoading: false
  });

  const prevProps = useRef(props).current;

  // componentDidMount
  useEffect(() => {
    loadNewGenericPage();
  }, []);

  // componentDidUpdate
  useEffect(() => {
    loadNewGenericPage();
    hideVisibleChildPanels();
  }, [props.screenId]);

  const loadNewGenericPage = () => {
    props.fetchScreenInfo(props.screenId);
  };

  const onItemSelectionChanged = (rowId) => {};

  const hideVisibleChildPanels = () => {
    if (!_.isEmpty(state.visiblePanels)) {
      setState({ ...state, visiblePanels: [] });
    }
  };

  const onPanelVisible = (panelNumber) => {
    if (!state.visiblePanels.includes(panelNumber)) {
      setState({
        ...state,
        visiblePanels: [...state.visiblePanels, panelNumber],
      });
    }
  };

  const onPanelHidden = (panelNumber) => {
    if (state.visiblePanels.includes(panelNumber)) {
      // this.setState((state) => {
      //   let panelList = state.visiblePanels;
      //   panelList = panelList.filter((pnlNmbr) => pnlNmbr !== panelNumber);
      //   return { visiblePanels: [] };
      // });
      setState({ ...state, visiblePanels: [] });
    }
  };

  const onIsLoading = (isLoading) => {
    setState({...state, isLoading: isLoading });
  }

  const hasVisiblePanels = () => {
    var visible = false;
    if (state.visiblePanels.length === 0) {
      return visible;
    } else {
      for (var index = 0; index < props.screenInfo.panels.length; index++) {
        visible = isPanelVisible(props.screenInfo.panels[index]);
      }
    }
    return visible;
  };

  const isPanelVisible = (panel) => {
    var visible = false;

    if (panel.parentPanels == undefined || panel.parentPanels.length == 0) {
      /*This is a parent panel and is always visible*/
      visible = true;
    } else {
      /*this is a child panel check if parent is selected*/
      visible = false;
      for (var index = 0; index < panel.parentPanels.length; index++) {
        var parent = Object.values(state.visiblePanels).filter(
          (panelNumber) => panelNumber === panel.parentPanels[index]
        )[0];
        if (parent != undefined) {
          visible = true;
        }
      }
    }
    return visible;
  };

  const panelNavigationItems = () => {
    return (
      <Nav className="justify-content-end fixed-top generic-page-nav generic-page-nav generic-page-nav-seacomlavender">
        {props.screenInfo.panels
          .filter((panel) => panel.visible || !panel.displayAsTab)
          .map((panel) => {
            var key = panel.id;
            if (isPanelVisible(panel)) {
              return (
                <Nav.Item
                  key={key}
                  className="generic-page-nav-item generic-page-nav-item generic-page-nav-item-seacomlavender"
                >
                  <Nav.Link
                    eventKey={key}
                    href={`#`}
                    onClick={(e) => {
                      var id = `#${panel.header.replaceAll(" ", "_")}`;
                      var panelbox = document.querySelector(`${id}`);
                      window.scrollTo({
                        left: 0,
                        top:
                          panel.panelNumber === 1
                            ? 0
                            : panelbox.offsetTop - 100,
                        behavior: "smooth",
                      });
                    }}
                  >
                    {panel.header}
                  </Nav.Link>
                </Nav.Item>
              );
            }
          })}
        ;
      </Nav>
    );
  };

  const renderLoading = () => {
    if(state.isLoading) {
      return <LoadingSpinnerOverlay className="d-flex justify-content-center " />;
    }
  };

  if (_.isEmpty(props.screenInfo) || _.isEmpty(props.screenInfo.panels)) {
    return null;
  } else {
    return (
      <div>
        {renderLoading()}
        <div>{panelNavigationItems()}</div>
        <div className="generic-page-base-page ">
          <BasePage title={props.screenInfo.name}>
            {/* <TestPanel /> */}
            {props.screenInfo.panels
              .filter((x) => !x.displayAsTab)
              .map((x, index) => {
                var id = x.header.replaceAll(" ", "_");

                if (x.panelType === 0) {
                  //Search Panel
                  return (
                    <div key={x.id} id={id} className="mb-3">
                      {isPanelVisible(x) && (
                        <SearchPanel
                          location={props.location}
                          hideVisibleChildPanels={hideVisibleChildPanels}
                          panelId={x.id}
                          screenId={props.screenId}
                        />
                      )}
                    </div>
                  );
                } else if (x.panelType === 1) {
                  //Overview Panel
                  return (
                    <div key={x.id} id={id} className="mb-3">
                      {isPanelVisible(x) && (
                        <OverviewPanelDatagrid
                          location={props.location}
                          onPanelVisible={onPanelVisible}
                          onPanelHidden={onPanelHidden}
                          onIsLoading={onIsLoading}
                          panelId={x.id}
                          screenId={props.screenId}
                        />
                      )}
                    </div>
                  );
                } else {
                  // Detail Panel
                  return (
                    <div key={x.id} id={id} className="mb-3">
                      {isPanelVisible(x) && (
                        <DetailPanel
                          childRef={(detailPanel) =>
                            (detailPanelRef = detailPanel)
                          }
                          onPanelVisible={onPanelVisible}
                          onPanelHidden={onPanelHidden}
                          onIsLoading={onIsLoading}
                          panelId={x.id}
                          screenId={props.screenId}
                        />
                      )}
                    </div>
                  );
                }
              })}

            {state.visiblePanels.length > 0 && hasVisiblePanels() && (
              <Tabs className="generic-page-tabs">
                {props.screenInfo.panels
                  .filter((x) => x.displayAsTab)
                  .map((tabPanel, index) => {
                    var id = tabPanel.header.replaceAll(" ", "_");

                    return (
                      <Tab
                        key={`${tabPanel.id}_${tabPanel.header}`}
                        id={id}
                        eventKey={tabPanel.header}
                        title={`${tabPanel.header}`}
                        className="generic-page-tab"
                      >
                        {tabPanel.panelType === 0 &&
                          isPanelVisible(tabPanel) && (
                            <SearchPanel
                              location={props.location}
                              onPanelVisible={onPanelVisible}
                              onPanelHidden={onPanelHidden}
                              panelId={tabPanel.id}
                              screenId={props.screenId}
                            />
                          )}
                        {tabPanel.panelType === 1 &&
                          isPanelVisible(tabPanel) && (
                            <OverviewPanelDatagrid
                              location={props.location}
                              onPanelVisible={onPanelVisible}
                              onPanelHidden={onPanelHidden}
                              panelId={tabPanel.id}
                              screenId={props.screenId}
                            />
                          )}
                        {tabPanel.panelType === 2 && isPanelVisible(tabPanel) && (
                          <DetailPanel
                            // ref={detailPanelRef}
                            onPanelVisible={onPanelVisible}
                            onPanelHidden={onPanelHidden}
                            panelId={tabPanel.id}
                            screenId={props.screenId}
                          />
                        )}
                      </Tab>
                    );
                  })}
              </Tabs>
            )}
          </BasePage>
        </div>
      </div>
    );
  }
}

GenericPage.propTypes = {
  fetchScreenInfo: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const values = queryString.parse(ownProps.location.search);
  return {
    fetchingData: state.fetchingData === true,
    auth: state.auth,
    screenId: values.screenId,
    parent: values.parent,
    screenInfo: state.screenInfo,
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    fetchScreenInfo: (screenId) => dispatch(fetchScreenInfo(screenId)),
  })
)(GenericPage);
